export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мекенжайды тексеру"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мекенжайды енгізіңіз"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Блокчейнді таңдаңыз"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тексеруді орындау"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Төмен қауіп"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Орташа қауіп"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жоғары қауіп"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Қара тізімде жоқ"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Басқа мекенжайды тексеру"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PDF жүктеп алу"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Артқа"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Провайдерді таңдаңыз"])}
}